import { Amplify } from 'aws-amplify';

// Configuration for AWS Amplify
const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID || '',
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: 'code' as 'code',
      userAttributes: {
        email: {
          required: true,
        },
      },
      passwordFormat: {
        minLength: 8,
        requireLowerCase: true,
        requireUpperCase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    }
  }
};

Amplify.configure(amplifyConfig);

export default amplifyConfig;
